import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_CORE_URL;

export const INFO = 'INFO';
export const ERROR = 'ERROR';

// post error values
export const PostLog = (body) => {
	return axios.post(`${apiUrl}/log`, body, {
		withCredentials: true,
	});
};
